// extracted by mini-css-extract-plugin
module.exports = {"BrainhubCarousel__customArrows":"carousel_BrainhubCarousel__customArrows__1Ubyv"};